import { put, takeLatest} from "redux-saga/effects";
import {RESET_ALERT_MSG, SET_ALERT_MSG} from "@actions/actionTypes";

function* setErrorMsg({value}) {
     yield put({type: SET_ALERT_MSG,  data: {type: "error", messages: value}});
}

export default function* errorSaga () {
    yield takeLatest(RESET_ALERT_MSG, setErrorMsg);
}